import {Inject, Pipe, PipeTransform} from '@angular/core';
import * as _ from "lodash";
import {TranslateService} from '@ngx-translate/core';
import {getMetersPerLargeDistanceUnit, METERS_PER_KILOMETER} from '../../utils/distance-unit.util';

@Pipe({
  standalone: false,
  name: 'bringozSpeed'
})
export class BringozSpeedPipe implements PipeTransform {

  private factor: number;
  private speedConfig: any;

  constructor(@Inject('splitService') private splitService, @Inject(TranslateService) private translateService: TranslateService) {
    this.speedConfig = this.splitService.getSiteDistanceLargeUnit(true);
    this.factor = getMetersPerLargeDistanceUnit(this.speedConfig === 'MI') / METERS_PER_KILOMETER;
  }

  transform(speedKmh: number, defaultValue: string = '---', showUnit?: boolean): string {
    if (!_.isUndefined(speedKmh)) {
      const unitKey = this.speedConfig === 'MI' ? 'MPH' : 'KMH';
      return `${(speedKmh / this.factor).toFixed(0).toString()}${showUnit ? ' ' + this.translateService.instant(unitKey) : ''}`;
    } else {
      return defaultValue;
    }
  }
}
